module.exports = __webpack_public_path__ + "img/pay_refund.f4ee3ca6.png";